<template>
  <div class="flex h-full flex-col">
    <RouterView />
  </div>
</template>

<script>
/**
 * Frame of an open accounting document, outside the invoicing menu as in
 * Funeral Manager (TheInvoicingShowLayout): the tab draws the whole page.
 */
export default {
  name: 'TheInvoicingShowPage'
}
</script>
